import { useLocaleKeys } from '~/i18n';
import { useAgreementsChipConnector } from './agreementsChipConnector';
export const useAgreementSettingsGrammar = ()=>{
    const { t } = useLocaleKeys('agreement.dashboard.aiSearch');
    const { t: commonFilter } = useLocaleKeys('common.filter');
    const connector = useAgreementsChipConnector();
    return {
        tone: 'default',
        connector,
        apply: commonFilter.apply(),
        valueSet: t.settingsValueSet(),
        fields: {
            netTerms: {
                bi: 'agreements_ai_chip_settings_net_terms',
                label: t.netDaysLabel(),
                suffix: t.netDaysSuffix(),
                validationError: t.netDaysValidationError(),
                valueIs: (value)=>t.netDaysValueIs({
                        value
                    }),
                valueOver: (value)=>t.netDaysValueOver({
                        value
                    }),
                valueUnder: (value)=>t.netDaysValueUnder({
                        value
                    })
            },
            requirePaymentMethod: {
                bi: 'agreements_ai_chip_settings_require_payment_method',
                label: t.settingsPaymentMethodLabel(),
                required: t.settingsPaymentMethodRequired(),
                notRequired: t.settingsPaymentMethodNotRequired()
            },
            creditCardFeesPaidBy: {
                bi: 'agreements_ai_chip_settings_credit_card_fees',
                label: t.settingsCcFeesLabel(),
                paidByClient: t.settingsCcFeesPaidByClient(),
                paidByServiceProvider: t.settingsCcFeesPaidByServiceProvider()
            },
            amendmentsApprovalMethod: {
                bi: 'agreements_ai_chip_remove_settings_amendments_approval_method',
                label: t.settingsAmendmentsFieldLabel(),
                auto: t.settingsApprovalApprovedAuto(),
                autoAfter: (days)=>t.settingsApprovalApprovedAutoAfter({
                        days
                    }),
                manual: t.settingsApprovalApprovedManual()
            },
            outOfScopeChargesApprovalMethod: {
                bi: 'agreements_ai_chip_remove_settings_out_of_scope_charges_approval_method',
                label: t.settingsOosApprovalLabel(),
                auto: t.settingsApprovalAuto(),
                autoAfter: (days)=>t.settingsApprovalAutoAfter({
                        days
                    }),
                manual: t.settingsApprovalManual()
            },
            termsOfService: {
                bi: 'agreements_ai_chip_remove_settings_terms_of_service',
                exists: t.settingsTermsOfServiceExists(),
                notExists: t.settingsTermsOfServiceNotExists()
            }
        }
    };
};
